// Billboard Data
const pi = Math.PI;
export const billboardData = [
    {
        modelPath: './models/me_newPoster_Compressed.glb',
        position: [-5, -7.2, 6.8],
        scale: [.7, .7, .7],
        rotation: [0.1, pi * 180 / 2 * pi, .10],
        contentType: "aboutMe"
    },
    {
        modelPath: './models/phonici_newPoster_Compressed.glb',
        position: [1.9, -7.8, 17],
        scale: [.6, .6, .6],
        rotation: [0, pi * 180 / pi, 0],
        contentType: "phonici"
    },
    {
        modelPath: './models/hci_newPoster_Compressed.glb',
        position: [-4.5, -7.8, 13.2],
        scale: [.6, .6, .6],
        rotation: [0, .8, 0],
        contentType: "hci"
    },
    {
        modelPath: "./models/otherProjects_newPoster_Compressed.glb",
        position: [-17.9, -7.8, 21.2],
        scale: [.6, .6, .6],
        rotation: [0, 141.1, 0],
        contentType: "otherProjects"
    },
    {
        modelPath: "./models/fieldStats_newPoster_Compressed.glb",
        position: [-5.9, -7.8, 21.5],
        scale: [.6, .6, .6],
        rotation: [0, 90.5, 0],
        contentType: "fieldStats"
    },
    {
        modelPath: "./models/rocket_newPoster_Compressed.glb",
        position: [-11.9, -7.8, 13.2],
        scale: [.6, .6, .6],
        rotation: [0, 100.3, 0],
        contentType: "oneSmallStep"
    }
];
